module.exports = __webpack_public_path__ + "static/media/bot.3b87f77f.png";